// --- Components ---
import ButtonGoback from "../../../components/button/buttonGoback";
import dayjs from 'dayjs';
import Select from "react-select";

// --- Models ---
import { ProblemItem } from "../../../models/types/problem";

// --- Utils ---
import { useLookupStation, useLookupProblemStatus } from "../../../utils/get-lookup";
import { useTranslation } from "react-i18next";

interface FormProps {
    data: ProblemItem | null;
    handleUpdateStatus: (statusId: number) => void;
}

export default function ProblemView({ data, handleUpdateStatus }: FormProps) {
    const { lookupStation } = useLookupStation();
    const { lookupProblemStatus } = useLookupProblemStatus();
    const { t } = useTranslation();

    if (!data) return null;
    return (
        <>
            <div className="w-full h-full" >
                <div className="flex justify-between items-center mb-4 sticky top-0 z-10 bg-gray-100">
                    <ButtonGoback />
                </div>
                <div className="flex flex-col gap-2 rounded-lg border border-gray-200 shadow-sm bg-white p-4 mb-2">
                    <div className="flex items-end gap-2">
                        <span className="font-semibold text-gray-600 ">{t("problem.view.labels.stationName")}:</span>
                        <span className="font-medium text-[20px] text-green-600">{lookupStation.find((item) => item.value === data?.stationId)?.label}</span>
                    </div>
                    <div className="flex gap-2">
                        <span className="font-semibold text-gray-600">{t("problem.view.labels.problemType")}:</span>
                        <span className="font-medium">{data?.problemTypeName}</span>
                    </div>
                    <div className="flex gap-2">
                        <span className="font-semibold text-gray-600">{t("problem.view.labels.description")}:</span>
                        <span className="font-medium">{data?.description}</span>
                    </div>
                    <div className="flex gap-2">
                        <span className="font-semibold text-gray-600">{t("problem.view.labels.startDate")}:</span>
                        <span className="font-medium">{data?.start ? dayjs(data?.start).format('DD/MM/YYYY') : '-'}</span>
                    </div>
                    <div className="flex gap-2">
                        <span className="font-semibold text-gray-600">{t("problem.view.labels.endDate")}:</span>
                        <span className="font-medium">{data?.end ? dayjs(data?.end).format('DD/MM/YYYY') : '-'}</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="font-semibold text-gray-600">{t("problem.view.labels.status")}:</span>
                        <Select
                            options={lookupProblemStatus}
                            value={lookupProblemStatus.find((item) => item.value === data?.status)}
                            isMulti={false}
                            placeholder={t("problem.view.placeholders.selectStatus")}
                            className=""
                            onChange={(e) => handleUpdateStatus(e?.value)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}